var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeseriesCirclerighticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2896_3549",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.451172,
    y: 0.625,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2896_3549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0135 10.6243L8.45101 13.1868L9.61768 14.3743L13.3677 10.6243L9.61768 6.87435L8.45101 8.06185L11.0135 10.6243ZM10.451 18.9577C9.29823 18.9577 8.2149 18.7389 7.20101 18.3014C6.18712 17.8639 5.30518 17.2702 4.55518 16.5202C3.80518 15.7702 3.21143 14.8882 2.77393 13.8743C2.33643 12.8605 2.11768 11.7771 2.11768 10.6243C2.11768 9.47157 2.33643 8.38824 2.77393 7.37435C3.21143 6.36046 3.80518 5.47852 4.55518 4.72852C5.30518 3.97852 6.18712 3.38477 7.20101 2.94727C8.2149 2.50977 9.29823 2.29102 10.451 2.29102C11.6038 2.29102 12.6871 2.50977 13.701 2.94727C14.7149 3.38477 15.5968 3.97852 16.3468 4.72852C17.0968 5.47852 17.6906 6.36046 18.1281 7.37435C18.5656 8.38824 18.7843 9.47157 18.7843 10.6243C18.7843 11.7771 18.5656 12.8605 18.1281 13.8743C17.6906 14.8882 17.0968 15.7702 16.3468 16.5202C15.5968 17.2702 14.7149 17.8639 13.701 18.3014C12.6871 18.7389 11.6038 18.9577 10.451 18.9577Z",
    fill: "#393939"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeseriesCirclerighticon);
export default __webpack_public_path__ + "static/media/Timeseries_circlerighticon.367026bd6a1feef6b289c49aeebafac8.svg";
export { ForwardRef as ReactComponent };